import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const OfferingsTranslations = wrapTranslationsSchema({
	name: 'OfferingsTranslations',
	title: 'Offerings Translations',
	sanityId: 'offerings',
	fields: {
		includedItems: 'Items that are included in this package',
		included: 'Offerings Included',
		related: 'Related Offerings',
		viewInStore: '{offeringTitle} in {storeTitle}',
		offeringTypeGoods: 'Goods',
		offeringTypeServices: 'Services',
		offeringTypeKnowledge: 'Knowledge',
	},
});
